export default "__VITE_ASSET__BsXhTeYy__"